import { Controller } from 'stimulus'

export default class extends Controller {
  onChangeSort (e) {
    const value = $(e.target).val()
    const currentScopes = $(e.target).data('current-scopes')
    Turbolinks.visit(`/catalog?sort=${value}&${currentScopes}`)
  }
}
